import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [
    NotificationsComponent
  ],
  imports: [
    CommonModule, RouterModule, MaterialModule
  ]
})
export class NotificationsModule { }
